import React from "react";
import { FaTrash, FaUser } from "react-icons/fa";
import styled from "styled-components";
import ActionConfirmationButton from "../../../components/pages/CourseAuthor/ActionConfirmation";
import { UserLink, UserName } from "../../../components/pages/Users";
import { IUser } from "../../Analytics/Common";

const UserRow = styled.div`
  display: flex;
`;

const StyledUserLink = styled(UserLink)`
  width: 85rem;
  width: stretch;
`;

interface IUserAutocompleteRowProps {
  user: IUser;
  removeUser: (accountId: string) => () => void;
}

const UserAutocompleteRow: React.FC<IUserAutocompleteRowProps> = props => (
  <UserRow key={props.user.accountId}>
    <StyledUserLink to={"#"}>
      <FaUser />
      <UserName>{props.user.displayName}</UserName>
    </StyledUserLink>
    <ActionConfirmationButton action="Delete" actionFn={props.removeUser(props.user.accountId)} ActionIcon={FaTrash} />
  </UserRow>
);

export default UserAutocompleteRow;
